


<ng-template #dialogCta>
    <neo-acciones-dialog #accionesDialogoCta
      [dialogTittle]="tituloDialog"
      [botonera]="botonera"
      (accionBoton)="submitForm($event)">

      <p>{{descripcionDialog}}</p>
      <p *ngIf="tfnoCta1">
        <span class="lnk-icon-circle">
            <i class="icon-16 icon-ibm-phone"></i>
            <a class="text-underline" href="tel:{{tfnoCta1}}" title="" target="_blank">{{tfnoCta1}}</a>
            <span *ngIf="tfnoCta2">/</span>
            <a *ngIf="tfnoCta2" class="text-underline" href="tel:{{tfnoCta2}}" title="" target="_blank">{{tfnoCta2}}</a>
        </span>
      </p>
      <p *ngIf="mailCta">
        <a class="lnk-icon-circle" href="mailto:{{mailCta}}" title="" target="_blank">
          <i class="icon-16 icon-ibm-email"></i>
          <span class="text-underline">{{mailCta}}</span>
        </a>
      </p>
      <neo-formulario-contacto-front [class]="'form-sm'" *ngIf="formContacto; else tempFormularioMainCta"></neo-formulario-contacto-front>
      <ng-template #tempFormularioMainCta>
        <neo-formulario class="mt-30 display-block" #formularioMainCta
        [camposFormulario]="inputsMainCta"
        [aplicarFlex]=false
        [formularioAncho]="'formulario-ancho-completo'"
        (campoCheckboxLinkClick)="dialog.open(dialogPrivacidad, {disableClose: false, minWidth: '360px', width: '360px',  panelClass: ['dialogoPrivacidad']})"
        ></neo-formulario>
      </ng-template>
    </neo-acciones-dialog>
</ng-template>

<ng-template #dialogPrivacidad>
    <neo-acciones-dialog
      [dialogTittle]="tituloDialogPrivacidad">
      <p>{{descripcionDialogPrivacidad}}</p>
    </neo-acciones-dialog>
  </ng-template>


